webpackJsonp([77653406118394],{

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  font-size: ', ';\n'], ['\n  text-align: center;\n  font-size: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n  display: block;\n  text-align: center;\n'], ['\n  font-size: ', ';\n  display: block;\n  text-align: center;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  padding: ', ' 0;\n  font-weight: bold;\n  color: ', ';\n  font-size: ', ';\n  display: block;\n  position: relative;\n  text-decoration: underline;\n  transition: 0.3s;\n\n  &:hover {\n      color: ', ';\n      transition: 0.3s;\n  }\n'], ['\n  text-align: center;\n  padding: ', ' 0;\n  font-weight: bold;\n  color: ', ';\n  font-size: ', ';\n  display: block;\n  position: relative;\n  text-decoration: underline;\n  transition: 0.3s;\n\n  &:hover {\n      color: ', ';\n      transition: 0.3s;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _graphql = __webpack_require__(13);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _PostList = __webpack_require__(119);
	
	var _PostList2 = _interopRequireDefault(_PostList);
	
	var _reactIntl = __webpack_require__(7);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Header = _styledComponents2.default.header(_templateObject, function (_ref) {
	  var theme = _ref.theme;
	  return theme.scale(1);
	});
	
	var TagName = _styledComponents2.default.span(_templateObject2, function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.scale(5);
	});
	
	var AllTagsLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject3, function (_ref3) {
	  var theme = _ref3.theme;
	  return theme.scale(1);
	}, function (_ref4) {
	  var theme = _ref4.theme;
	  return theme.colors.yellow;
	}, function (_ref5) {
	  var theme = _ref5.theme;
	  return theme.scale(0);
	}, function (_ref6) {
	  var theme = _ref6.theme;
	  return theme.colors.white;
	});
	
	var TagRoute = function TagRoute(_ref7) {
	  var data = _ref7.data,
	      pathContext = _ref7.pathContext;
	
	  var posts = data.allMarkdownRemark.edges.map(function (p) {
	    return p.node;
	  });
	
	  var allTagsLink = _react2.default.createElement(
	    _reactIntl.FormattedMessage,
	    { id: 'tags.allTagsLink' },
	    function (txt) {
	      return _react2.default.createElement(
	        AllTagsLink,
	        {
	          to: '/' + pathContext.langKey + '/tags/'
	        },
	        txt
	      );
	    }
	  );
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      Header,
	      null,
	      _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'tags' },
	        function (txt) {
	          return _react2.default.createElement(_reactHelmet2.default, {
	            title: pathContext.tag + ' | ' + txt,
	            meta: [{ name: 'description', content: txt }]
	          });
	        }
	      ),
	      _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'tags.nPostsTaggedWith',
	        values: { nPosts: data.allMarkdownRemark.totalCount }
	      }),
	      _react2.default.createElement(
	        TagName,
	        null,
	        '\u201C',
	        pathContext.tag,
	        '\u201D'
	      ),
	      allTagsLink
	    ),
	    _react2.default.createElement(_PostList2.default, {
	      posts: posts
	    }),
	    _react2.default.createElement(
	      'footer',
	      null,
	      allTagsLink
	    )
	  );
	};
	
	TagRoute.propTypes = {
	  data: _propTypes2.default.object,
	  pathContext: _propTypes2.default.object
	};
	
	exports.default = TagRoute;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tag-page-js-269cd5ca06d484376cf4.js